import {
  importProvidersFrom,
  makeEnvironmentProviders,
  type EnvironmentProviders,
} from '@angular/core';
import { GRPC_INTERCEPTORS, GrpcCoreModule } from '@ngx-grpc/core';
import { GrpcWebClientModule } from '@ngx-grpc/grpc-web-client';
import { ImprobableEngGrpcWebClientModule } from '@ngx-grpc/improbable-eng-grpc-web-client';
import { grpc } from '@improbable-eng/grpc-web';
import { GrpcAuthInterceptor } from './grpc-auth.interceptor';

const xhr = grpc.CrossBrowserHttpTransport({
  /* withCredentials: true */
});

export function provideGrpc(): EnvironmentProviders {
  return makeEnvironmentProviders([
    importProvidersFrom(
      GrpcCoreModule.forRoot(),
      GrpcWebClientModule.forRoot({
        // settings: { host: 'http://localhost:8080' },
        settings: { host: '' /*, withCredentials: true */ },
      }),
      ImprobableEngGrpcWebClientModule.forRoot({
        settings: {
          host: '',
          transport: {
            unary: xhr,
            serverStream: xhr,
            // We not use clientStream and bidiStream
            clientStream: xhr,
            bidiStream: xhr,
          },
        },
      }),
    ),
    {
      provide: GRPC_INTERCEPTORS,
      multi: true,
      useClass: GrpcAuthInterceptor,
    },
  ]);
}
